import { readonly, ref } from 'vue';

const fullName = ref<string>('');
const firstName = ref<string>('');
const lastName = ref<string>('');
export default function useCustomerName() {

  function setFullName(newName: string) {
    fullName.value = newName;
  }

  function setFirstAndLastName(newFirstName: string, newLastName: string) {
    firstName.value = newFirstName;
    lastName.value = newLastName;
  }

  return {
    setFullName,
    setFirstAndLastName,
    fullName: readonly(fullName),
    firstName: readonly(firstName),
    lastName: readonly(lastName),
  };
}
